import { EChatbotFiltersModalActionTypes } from '../../actions/chatbotFiltersModal';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export const chatbotFiltersModalReducer = (state: TAppState, action: TReduxActions): TAppState => {
  switch (action.type) {
    case EChatbotFiltersModalActionTypes.Open:
      return {
        ...state,
        chatbotFiltersModal: {
          ...state.chatbotFiltersModal,
          isOpened: true,
        },
      };

    case EChatbotFiltersModalActionTypes.Close:
      return {
        ...state,
        chatbotFiltersModal: {
          ...state.chatbotFiltersModal,
          isOpened: false,
        },
      };

    case EChatbotFiltersModalActionTypes.SetManifest:
      return {
        ...state,
        chatbotFiltersModal: {
          ...state.chatbotFiltersModal,
          manifest: action.payload.manifest,
        },
      };

    case EChatbotFiltersModalActionTypes.SetManifestStatus:
      return {
        ...state,
        chatbotFiltersModal: {
          ...state.chatbotFiltersModal,
          manifestStatus: action.payload,
        },
      };

    case EChatbotFiltersModalActionTypes.SetFiltersLoading:
      return {
        ...state,
        chatbotFiltersModal: {
          ...state.chatbotFiltersModal,
          isFiltersLoading: action.payload,
        },
      };

    default:
      return state;
  }
};
